<svg [attr.class]="'bc-svg-icon icon icon-' + icon">
  <use xlink:href="" attr.xlink:href="{{ '#icon-' + icon }}"></use>
</svg>
